import { ThunkAction } from 'redux-thunk'
import { Dispatch } from 'redux'
import { RootState } from '../reducer'
import { ToastConstants } from './constants'
import { ToastAction, ToastWithoutId } from './types'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCross, faCheck } from '@fortawesome/free-solid-svg-icons'

type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  ToastAction
>

const trySerialize = (data: unknown): string => {
  try {
    const serialized = JSON.stringify(data)
    return serialized
  } catch (e) {
    return String(data)
  }
}

export const showErrorToast = (
  title: string,
  errors: unknown
): AppThunk => {
  return (dispatch: Dispatch<ToastAction>) => {
    dispatch({
      type: ToastConstants.ADD_ERROR_TOAST,
      toast: {
        backgroundColor: '#d9534f',
        title: title,
        description: trySerialize(errors),
        icon: <FontAwesomeIcon icon={faCross} />,
      },
    })
  }
}

export const showSuccessToast = (
  title: string,
  message: string
): AppThunk => {
  return (dispatch: Dispatch<ToastAction>) => {
    dispatch({
      type: ToastConstants.ADD_SUCCESS_TOAST,
      toast: {
        backgroundColor: 'green',
        title: title,
        description: message,
        icon: <FontAwesomeIcon icon={faCheck} />,
      },
    })
  }
}

export const ClearToasts = (): AppThunk => {
  return (dispatch: Dispatch<ToastAction>) => {
    dispatch({ type: ToastConstants.CLEAR_ALL_TOASTS })
  }
}
